var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%","min-height":"150"}},[_c('v-card-title',[_vm._v(" Name: "+_vm._s(_vm.content.username)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }